<template>
  <div class="question-storage-list">
    <b-tabs
      :value="activeIndex"
      lazy
      content-class="mt-1"
      @input="onTabInput"
    >
      <b-tab title="Вопросы">
        <storage-questions-tab />
      </b-tab>
      <b-tab title="Исполнители">
        <storage-artists-tab />
      </b-tab>
      <b-tab title="Пакеты">
        <storage-packs-tab />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BTab, BTabs } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import store from '@/store'
import questionStorageStoreModule from './questionStorageStoreModule'
import StorageQuestionsTab from './StorageQuestionsTab.vue'
import StorageArtistsTab from './StorageArtistsTab.vue'
import StoragePacksTab from './StoragePacksTab.vue'

const MODULE = 'question-storage'
const TABS = ['questions', 'artists', 'packs']

export default {
  components: {
    BTab, BTabs, StorageQuestionsTab, StorageArtistsTab, StoragePacksTab,
  },
  setup(props, { root }) {
    // Модуль стора не снимаем: Vue 2 создаёт компонент следующего роута до уничтожения текущего (см. import/PackImport.vue)
    if (!store.hasModule(MODULE)) store.registerModule(MODULE, questionStorageStoreModule)

    const activeIndex = computed(() => {
      const index = TABS.indexOf(root.$route.query.tab)

      return index === -1 ? 0 : index
    })

    // Смена вкладки: фильтры другой вкладки в URL не тащим, оставляем только ?tab=
    const onTabInput = index => {
      const tab = TABS[index] || TABS[0]
      if (tab === (root.$route.query.tab || TABS[0])) return
      root.$router.replace({ query: { tab } }).catch(() => {})
    }

    return { activeIndex, onTabInput }
  },
}
</script>
